import { styledForMobile } from "@l2r-front/l2r-ui"

import { DocumentFilterList as L2RDocumentFilterList } from "../../containers/DocumentFilterList/DocumentFilterList"

export const DocumentFilterList = styledForMobile(L2RDocumentFilterList)(({ theme }) => ({
    padding: theme.spacing(3, 0, 0, 0),
}))